const CustomersIndexPage = (resolve) => {
  require.ensure(["./customers/index.vue"], () => {
    resolve(require("./customers/index.vue"))
  }, "entries_customers")
}

const CustomerFormPage = (resolve) => {
  require.ensure(["./customers/form.vue"], () => {
    resolve(require("./customers/form.vue"))
  }, "entries_customers")
}

const VetsIndexPage = (resolve) => {
  require.ensure(["./vets/index.vue"], () => {
    resolve(require("./vets/index.vue"))
  }, "entries_vets")
}

const VetFormPage = (resolve) => {
  require.ensure(["./vets/form.vue"], () => {
    resolve(require("./vets/form.vue"))
  }, "entries_vets")
}

const SpeciesIndexPage = (resolve) => {
  require.ensure(["./species/index.vue"], () => {
    resolve(require("./species/index.vue"))
  }, "entries_species")
}

const RacesIndexPage = (resolve) => {
  require.ensure(["./races/index.vue"], () => {
    resolve(require("./races/index.vue"))
  }, "entries_races")
}

const OwnersIndexPage = (resolve) => {
  require.ensure(["./owners/index.vue"], () => {
    resolve(require("./owners/index.vue"))
  }, "entries_owners")
}

const OwnerAnimalsPage = (resolve) => {
  require.ensure(["./owners/animals.vue"], () => {
    resolve(require("./owners/animals.vue"))
  }, "entries_owners")
}

const AnimalsIndexPage = (resolve) => {
  require.ensure(["./animals/index.vue"], () => {
    resolve(require("./animals/index.vue"))
  }, "entries_animals")
}

const AnimalRegistrationsIndexPage = (resolve) => {
  require.ensure(["./animal-registrations/index.vue"], () => {
    resolve(require("./animal-registrations/index.vue"))
  }, "entries_animal_registrations")
}

const ShowAnimalRegistrationPage = (resolve) => {
  require.ensure(["./animal-registrations/show/show.vue"], () => {
    resolve(require("./animal-registrations/show/show.vue"))
  }, "entries_animal_registrations")
}

const OrgansIndexPage = (resolve) => {
  require.ensure(["./organs/index.vue"], () => {
    resolve(require("./organs/index.vue"))
  }, "entries_organs")
}

const OrganFormPage = (resolve) => {
  require.ensure(["./organs/form.vue"], () => {
    resolve(require("./organs/form.vue"))
  }, "entries_organs")
}

const CertTemplatesIndexPage = (resolve) => {
  require.ensure(["./cert-templates/index.vue"], () => {
    resolve(require("./cert-templates/index.vue"))
  }, "entries_cert_templates")
}

const ExamTypesIndexPage = (resolve) => {
  require.ensure(["./exam-types/index.vue"], () => {
    resolve(require("./exam-types/index.vue"))
  }, "entries_exam_types")
}

const ServicesIndexPage = (resolve) => {
  require.ensure(["./services/index.vue"], () => {
    resolve(require("./services/index.vue"))
  }, "entries_services")
}

const ServiceFormPage = (resolve) => {
  require.ensure(["./services/form.vue"], () => {
    resolve(require("./services/form.vue"))
  }, "entries_services")
}

export default (appRoutes) => {  
  appRoutes.push({ path: "entries/customers", component: CustomersIndexPage })
  appRoutes.push({ path: "entries/customers/:id", component: CustomerFormPage })
  appRoutes.push({ path: "entries/vets", component: VetsIndexPage })
  appRoutes.push({ path: "entries/vets/:id", component: VetFormPage })
  appRoutes.push({ path: "entries/species", component: SpeciesIndexPage })
  appRoutes.push({ path: "entries/races", component: RacesIndexPage })
  appRoutes.push({ path: "entries/owners", component: OwnersIndexPage })
  appRoutes.push({ path: "entries/owners/:id/animals", component: OwnerAnimalsPage })
  appRoutes.push({ path: "entries/animals", component: AnimalsIndexPage })
  appRoutes.push({ path: "entries/animal-registrations", component: AnimalRegistrationsIndexPage })
  appRoutes.push({ path: "entries/animal-registrations/:id", component: ShowAnimalRegistrationPage })
  appRoutes.push({ path: "entries/organs", component: OrgansIndexPage })
  appRoutes.push({ path: "entries/organs/:id", component: OrganFormPage })
  appRoutes.push({ path: "entries/cert-templates", component: CertTemplatesIndexPage })
  appRoutes.push({ path: "entries/exam-types", component: ExamTypesIndexPage })
  appRoutes.push({ path: "entries/services", component: ServicesIndexPage })
  appRoutes.push({ path: "entries/services/:id", component: ServiceFormPage })  
}